import React from 'react'

export default function TimeIcon() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 12H11.5C11.5 12.1326 11.5527 12.2598 11.6464 12.3536L12 12ZM22 12H21.5C21.5 17.2467 17.2467 21.5 12 21.5V22V22.5C17.799 22.5 22.5 17.799 22.5 12H22ZM12 22V21.5C6.75329 21.5 2.5 17.2467 2.5 12H2H1.5C1.5 17.799 6.20101 22.5 12 22.5V22ZM2 12H2.5C2.5 6.75329 6.75329 2.5 12 2.5V2V1.5C6.20101 1.5 1.5 6.20101 1.5 12H2ZM12 2V2.5C17.2467 2.5 21.5 6.75329 21.5 12H22H22.5C22.5 6.20101 17.799 1.5 12 1.5V2ZM12 8H11.5V12H12H12.5V8H12ZM12 12L11.6464 12.3536L14.1464 14.8536L14.5 14.5L14.8536 14.1464L12.3536 11.6464L12 12Z" fill="currentColor" fillOpacity="0.5" />
        </svg>

    )
}
